module.exports = __webpack_public_path__ + "static/abdallah-11cb0fb04d163b99b20f2bbaf74c74a7.jpg";